<template>
  <v-container fluid class="pa-0"
    style="position: relative; max-height: calc(100vh - 94px); min-height: calc(100vh - 94px); ">
    <!--<v-alert type="success"
             icon="mdi-account-hard-hat"
             class="rounded-l-0 px-4 py-2 mt-2"
             id="oldgui_frame_alert">
      This page is not available in the new gui yet, so we made the old gui available here.
    </v-alert>
    -->
    <overlay-loading :loading="loading"></overlay-loading>
    <iframe id="iframe_oldgui" :key="$route.name"
      style="width: 100%; max-height: calc(100vh - 94px); min-height: calc(100vh - 94px); overflow-y:auto; border: none;"
      :src="GenerateURL()" @load="onloaded()">
    </iframe>
  </v-container>
</template>


<script>
import OverlayLoading from "@/components/Sections/OverlayLoading.vue";

export default {
  name: "OldGuiFrame",
  props: {},
  components: { OverlayLoading },

  data() {
    return {
      loading: true
    };
  },

  mounted() {
    //setTimeout(() => this.doMagic(), 1000);
    //setTimeout(() => this.doMagic2(), 2000);
  },

  methods: {
    onloaded() {
      this.loading = false;
      this.installCleanUiGuards();
      this.hideDepricatedUiItems();
    },

    GenerateURL() {
      var url = this.getRoute({ page: this.$route.name, params: this.$route.params, guiver: "old", travel: false });
      //url = "https://test1.qwips.net/ServiceProviderWebSite/Views/Job/ManageJobEdit.aspx?id=1084"
      url = url + (url.includes('?') ? '&' : '?') + "cleanui=true";
      //console.log("OldGuiFrame to ", url);
      return url;
    },

    installCleanUiGuards() {
      const iframe = document.getElementById("iframe_oldgui");
      const win = iframe?.contentWindow;
      const doc = iframe?.contentDocument;
      if (!win || !doc) return;

      const ensureParam = (raw) => {
        if (!raw) return raw;
        try {
          const u = new URL(raw, win.location.href);
          if (!u.searchParams.has('cleanui')) u.searchParams.set('cleanui', 'true');
          return u.toString();
        } catch {
          return raw;
        }
      };

      // 1) Intercept link clicks early (capture phase)
      const onClickCapture = (e) => {
        let a = e.target;
        while (a && a.tagName !== 'A') a = a.parentElement;
        if (!a || a.target === '_blank') return;

        const href = a.getAttribute('href');
        if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

        const amended = ensureParam(href);
        if (amended !== href) {
          e.preventDefault(); // stop default nav
          win.location.href = amended; // navigate with param — single load, no flicker
        }
      };
      doc.addEventListener('click', onClickCapture, true);

      // 2) Intercept form submissions
      const onSubmitCapture = (e) => {
        const form = e.target;
        if (!(form instanceof win.HTMLFormElement)) return;

        // Prefer adding a hidden input so server receives it too
        if (!form.querySelector('input[name="cleanui"]')) {
          const hidden = doc.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'cleanui';
          hidden.value = 'true';
          form.appendChild(hidden);
        }

        // Also normalize action URL (covers GET forms)
        const action = form.getAttribute('action') || win.location.href;
        const amended = ensureParam(action);
        if (amended !== action) form.setAttribute('action', amended);
      };
      doc.addEventListener('submit', onSubmitCapture, true);

      // 3) Patch SPA navigations
      const patchHistory = (method) => {
        const orig = win.history[method];
        win.history[method] = function (state, title, url) {
          if (typeof url === 'string') url = ensureParam(url);
          return orig.apply(this, [state, title, url]);
        };
      };
      patchHistory('pushState');
      patchHistory('replaceState');

      // 4) Normalize current URL once, without causing a second paint
      // Use replaceState to add the param without reload or flicker
      try {
        const u = new URL(win.location.href);
        if (!u.searchParams.has('cleanui')) {
          u.searchParams.set('cleanui', 'true');
          win.history.replaceState(win.history.state, document.title, u.toString());
        }
      } catch {
        // ignore
       }

      // 5) Keep future DOM-created links compliant
      const mo = new win.MutationObserver((mutations) => {
        mutations.forEach(m => {
          m.addedNodes.forEach(node => {
            if (!(node instanceof win.Element)) return;
            if (node.tagName === 'A' && node.hasAttribute('href')) {
              const href = node.getAttribute('href');
              const amended = ensureParam(href);
              if (amended !== href) node.setAttribute('href', amended);
            }
            node.querySelectorAll?.('a[href]').forEach(a => {
              const href = a.getAttribute('href');
              const amended = ensureParam(href);
              if (amended !== href) a.setAttribute('href', amended);
            });
          });
        });
      });
      mo.observe(doc.documentElement, { childList: true, subtree: true });
    },

    hideDepricatedUiItems() {
      var iframe = document?.getElementById("iframe_oldgui").contentDocument;
      if (iframe) {
        this.hideElement(iframe.getElementById("logout"));
        //this.hideElement(iframe.getElementById("left-menu"));
        this.hideElement(iframe.querySelector('[title="Live chat button"]'));
      }
    },

    hideElement(item) {
      if (item) {
        item.style.display = "none";
      }
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped>
#iframe_oldgui {
  z-index: 1 !important;
}

#oldgui_frame_alert {
  position: absolute;
  z-index: 20000;
  left: -10px;
}

#oldgui_frame_alert::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -6px;
  z-index: -1;
  width: 0;
  height: 0;
  border-right: 10px solid #52864b;
  border-top: 0px solid rgba(0, 0, 0, 0);
  border-bottom: 6px solid rgba(0, 0, 0, 0);
}
</style>